import { render, staticRenderFns } from "./TrialBalance.vue?vue&type=template&id=50de3704&scoped=true"
import script from "./TrialBalance.vue?vue&type=script&lang=js"
export * from "./TrialBalance.vue?vue&type=script&lang=js"
import style0 from "./TrialBalance.vue?vue&type=style&index=0&id=50de3704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50de3704",
  null
  
)

export default component.exports